import script from "./SearchChatsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchChatsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SearchChatsDialog.vue?vue&type=style&index=0&id=52ff2004&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ff2004"]])

export default __exports__